import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface HotelManagementProperties {
  id: number;
  hotelId: number;
  hotelName: string;
  hotelType: string;
  hotelCity: string;
  hotelAddress: string;
  hotelImage: string;
  hotelMapLocation: string;
  isActive: boolean;
  createdDate: string;
  updatedDate: string;
}

export interface HotelResponse {
  success: boolean;
  message: string;
  data?: HotelManagementProperties[];
  totalCount?: number;
}

@Injectable({ providedIn: 'root' })
export class HotelManagementService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  constructor(private http: HttpClient) {}

  getHotels(): Observable<HotelResponse> {
    return this.http.get<HotelResponse>(`${this.baseUrl}/hotel/getall`);
  }

  getHotel(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/hotel/get/${id}`);
  }

  addHotel(hotel: HotelManagementProperties): Observable<HotelResponse> {
    hotel.id = 0;
    return this.http.post<HotelResponse>(`${this.baseUrl}/hotel/add`, hotel);
  }

  updateHotel(id: number, hotel: HotelManagementProperties): Observable<HotelResponse> {
    return this.http.put<HotelResponse>(`${this.baseUrl}/hotel/update/${id}`, hotel);
  }

  deleteHotel(id: number): Observable<HotelResponse> {
    return this.http.delete<HotelResponse>(`${this.baseUrl}/hotel/delete/${id}`);
  }

  toggleStatus(id: number, isActive: boolean): Observable<HotelResponse> {
    return this.http.put<HotelResponse>(`${this.baseUrl}/hotel/${id}/toggle-status`, { isActive });
  }
}
